export default __webpack_public_path__ + "static/media/icon_category-interior.3e76861b.svg";